import React from 'react'
import Image from './image'

export default class PastPeople extends React.Component {
  render() {
    return (
      <section className="wrap past-people">
        <h2>Past/Current Artists & Speakers</h2>
        <ul>
          <li>MercyMe</li>
          <li>Max Lucado</li>
          <li>Mark Hall of Casting Crowns</li>
          <li>Steven Curtis Chapman</li>
          <li>Jeremy Camp</li>
          <li>Newsboys</li>
          <li>Jon Foreman of Switchfoot</li>
          <li>Dr. Gary Chapman - The 5 Love Languages</li>
          <li>Francesca Battistelli</li>
          <li>Michael Tait</li>
          <li>Karen Kingsbury - 10 Secrets to a Happy Marriage</li>
          <li>Kim Walker-Smith</li>
          <li>Tim Timmons</li>
          <li>Bart Millard</li>
          <li>Gary Thomas - Sacred Marriage</li>
          <li>Pastor Skip & Lenya Heitzig</li>
          <li>Christy Nockels</li>
          <li>Adie Camp</li>
          <li>Adam Agee of AudioA</li>
          <li>Leeland</li>
          <li>Matthew West</li>
          <li>Pastor Jim Wright</li>
          <li>Pastor Greg & Cathe Laurie</li>
          <li>Mike Donehey of Tenth Avenue North</li>
          <li>Jon Micah Sumrall of Kutless</li>
          <li>Matt Hammitt of Sanctus Real</li>
          <li>Phil Wickham</li>
          <li>Bob Goff - Love Does</li>
          <li>Mac Powell of Third Day</li>
          <li>Ellie Holcomb</li>
          <li>Chris August</li>
          <li>...and more!</li>
        </ul>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/past-people.js